import { Button as MuiButton, styled, ButtonProps } from '@mui/material'
import React from 'react'

const Button = styled((props: ButtonProps) => (
  <MuiButton size='medium' variant='contained' {...props} />
))(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
}))

export default Button
